import { Expose } from 'class-transformer';

export class ModelCountry {
    @Expose()
    id: string;

    @Expose()
    name: string;
}
